import { MessageCircle, ArrowUpRight } from "lucide-react";
import { SUPPORT } from "@/data/content";
import { Reveal, MaskReveal, SectionLabel, CtaButton, handleCta } from "./primitives";

export default function SupportSection() {
  return (
    <section id="contato" className="relative bg-brand-mist py-20 md:py-28">
      <div className="mx-auto max-w-5xl px-5 lg:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-[28px] border border-brand-navy/10 bg-white p-8 shadow-[0_30px_70px_-30px_rgba(10,25,47,0.2)] md:p-12">
            <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-brand-gold/10 blur-3xl" />
            <div className="relative flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
              <div className="max-w-xl">
                <SectionLabel>{SUPPORT.label}</SectionLabel>
                <h2 className="mt-5 font-display text-3xl font-semibold leading-[1.1] tracking-tight text-brand-navy sm:text-4xl">
                  <MaskReveal lines={[SUPPORT.title]} />
                </h2>
                <p className="mt-4 text-base leading-relaxed text-brand-navy/60 md:text-lg">
                  {SUPPORT.text}
                </p>
              </div>

              <div className="flex w-full shrink-0 flex-col items-start gap-4 md:w-auto md:items-end">
                <div className="flex items-center gap-3 rounded-2xl border border-brand-navy/10 bg-brand-mist/60 px-5 py-3">
                  <span className="grid h-10 w-10 place-items-center rounded-full bg-[#25D366]/15 text-[#25D366]">
                    <MessageCircle className="h-5 w-5" />
                  </span>
                  <div className="leading-tight">
                    <p className="text-[11px] font-semibold uppercase tracking-wider text-brand-navy/45">WhatsApp</p>
                    <p className="font-display text-lg font-semibold text-brand-navy">{SUPPORT.phoneLabel}</p>
                  </div>
                </div>
                <CtaButton
                  size="lg"
                  className="w-full md:w-auto"
                  onClick={() => handleCta("whatsappSupport")}
                  data-testid="support-whatsapp-cta"
                >
                  {SUPPORT.cta}
                  <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </CtaButton>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
